var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('img',{staticStyle:{"display":"none"},attrs:{"src":require("./assets/img/nullnetwork.jpg"),"alt":""}}),_c('contact',{ref:"contact",staticClass:"contact",on:{"click-toTop":_vm.toTop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }